import classNames from 'classnames'
import React, { useState } from 'react'

import { IInputProps, InputField, InputStyles } from 'core-components/library/inputs'

import { TranslateInputWrap } from './InputWrapper'

type Ref = HTMLInputElement

export interface ITranslateInputProps extends IInputProps {
  translation?: string
}

export const Input = React.forwardRef<Ref, ITranslateInputProps>((props, ref) => {
  const [focused, setFocused] = useState<boolean>(false)
  return (
    <TranslateInputWrap {...props} focused={focused}>
      <InputField
        {...props}
        focused={focused}
        inputRef={ref}
        setFocused={setFocused}
        className={classNames(InputStyles.control, {
          [InputStyles['control--focused']]:
            (props.label || props.translation) && (focused || props.value),
          [InputStyles['control--noSpin']]: props.type === 'number' && props.noNumberSpinner,
        })}
      />
    </TranslateInputWrap>
  )
})
